module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-00auto"
  }, [_c('div', {
    staticClass: "ksm-medien__icon",
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('film-neu.svg'))
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-00auto ksm-flex"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex-1"
  }, [(_vm.media) ? _c('PlayerControls', {
    attrs: {
      "media": _vm.media,
      "mediaType": "video",
      "mediaName": 'Film',
      "playBtnDisable": _vm.isConnect2
    },
    on: {
      "videoPlaying": _vm.videoPlaying,
      "playPause": _vm.playPause
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex-1 ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-flex-1",
    staticStyle: {
      "position": "relative"
    }
  }, [_c('div', {
    staticClass: "ksm-media-wrapper"
  }, [_c('video', {
    staticClass: "ksm-media"
  }, [_c('source', {
    attrs: {
      "src": "./static/multimedia/film.mp4",
      "type": "video/mp4"
    }
  })])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ksm-medien__audio-select"
  }, [_vm._v("Stummfilm (1929)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c62c3702","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/texte/ursonate/FilmView.vue
// module id = 1993
// module chunks = 1